/**
 * Context Provider module
 */
import {NgModule} from '@angular/core';
import { CoreModule } from '@ispm/core/core.module';
import {ContextProviderService} from '@ispm-client/modules/context-provider/services/context-provider.service';

@NgModule({
  imports: [
    CoreModule
  ],
  declarations: [
  ],
  providers: [ContextProviderService],
  exports: []


})
export class ContextProviderModule { }
